export default __webpack_public_path__ + "29493221ea69220211c30d893186b6b5.png";